import { render, staticRenderFns } from "./TabSidebar.vue?vue&type=template&id=cc273068&"
import script from "./TabSidebar.vue?vue&type=script&lang=js&"
export * from "./TabSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TabSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports